export function setupAntiDebug(options?: { bypass?: boolean }) {
  if (typeof window === 'undefined') return
  if (options?.bypass) return

  const normalized = (key: string) => key.toLowerCase()
  const isBlockedCombo = (e: KeyboardEvent) => {
    const key = normalized(e.key)
    const ctrlOrMeta = e.ctrlKey || e.metaKey
    const withShift = e.shiftKey
    const withAlt = e.altKey
    const f12 = key === 'f12' || e.keyCode === 123
    const inspectLike = ctrlOrMeta && withShift && (key === 'i' || key === 'j' || key === 'c' || key === 'k')
    const macAltInspect = e.metaKey && withAlt && (key === 'i' || key === 'j' || key === 'c')
    const viewSource = ctrlOrMeta && key === 'u'
    return f12 || inspectLike || macAltInspect || viewSource
  }

  const handlerKey = (e: KeyboardEvent) => {
    if (isBlockedCombo(e)) {
      e.preventDefault()
      e.stopPropagation()
    }
  }
  const handlerContext = (e: MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
  }
  window.addEventListener('keydown', handlerKey, true)
  document.addEventListener('keydown', handlerKey, true)
  window.addEventListener('contextmenu', handlerContext, true)
  document.addEventListener('contextmenu', handlerContext, true)
  
  let checkTimer: number | null = null
  const checkDevtools = () => {
    checkTimer = window.setTimeout(checkDevtools, 1500)
  }
  checkDevtools()
  
  return () => {
    window.removeEventListener('keydown', handlerKey, true)
    document.removeEventListener('keydown', handlerKey, true)
    window.removeEventListener('contextmenu', handlerContext, true)
    document.removeEventListener('contextmenu', handlerContext, true)
    if (checkTimer) {
      window.clearTimeout(checkTimer)
      checkTimer = null
    }
  }
}
